import React from "react";
import classNames from "classnames";
import { SpinnerProps } from "./types";
import styles from "./spinner.module.scss";

export const Spinner = ({ size = 80, className }: SpinnerProps) => {
    return (
        <svg
            className={classNames(styles.spinner, className)}
            width={size}
            height={size}
            viewBox="0 0 56 56"
            fill="none"
        >
            <circle cx="28" cy="28" r="24" stroke="#D9D9D9" strokeWidth="8" />
            <path
                d="M4.015 28.838a24 24 0 0 1 47.97-1.676"
                stroke="#3B85F7"
                strokeWidth="8"
                strokeLinecap="round"
            />
        </svg>
    );
};